import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
  getCallCenter,
  getCertifyFlag,
  getHtmComPassCheck,
  getMagamFlag,
  getMobileAgree,
  getYAStart,
  getYaStartYN,
  setAgree,
  setYaStart,
} from '../features/common/commonSlice';
import AlertContext from '../context/AlertContext';
import { useTranslation } from 'react-i18next';
import { getInsaInfoLoad } from '../features/myInfo/myInfoSlice';
import { setLogin } from '../features/login/loginSlice';

//로그인, 인증여부 체크
const AuthRoute = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useTranslation('common');
  const sessionId = sStorage.getItem('sessionId');
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const { isLogin } = useSelector(state => state.login);
  const { isMagamChecked, isCertifyChecked, yaStart, compassCheck, callcenter } = useSelector(
    state => state.common,
  );
  const { myInfo } = useSelector(state => state.myInfo);
  const { certifyFlag } = useSelector(state => state.common);
  const [isAuthLoaded, setIsAuthLoaded] = useState(false);

  useEffect(() => {
    if (sessionId) {
      fetchAuthFlags();
    }
  }, [dispatch, sessionId]);

  const fetchAuthFlags = async () => {
    try {
      // if (!isMagamChecked) {
      await dispatch(getMagamFlag()).unwrap();
      // }
      // if (!isCertifyChecked) {
      await dispatch(getCertifyFlag()).unwrap();
      // }
      //IsAuthLoaded slice로 빼야될지 고민해야함 yaStartYN보다 children이 먼저 로딩되는 문제가 있을 수 있어
      //일단 agree일 때 조건 추가해서 하긴했거든? 나중에 확인해봐
      setIsAuthLoaded(true);
    } catch (error) {
      console.error('인증 플래그 가져오기 오류:', error);
      // 에러 처리 로직 추가 가능
    }
  };

  useEffect(() => {
    //최초 비밀번호 변경 안했을때만 태운다
    if (sessionId && !compassCheck) {
      handleLogin();
      dispatch(setLogin(true));
    }
  }, [sessionId]);

  useEffect(() => {
    //YaStart 안탔을 경우 태운다
    console.log('isYaStart >>', yaStart);
    if (!yaStart && isLogin && sessionId) {
      handleYaStartYN();
    }
  }, [yaStart, isLogin]);

  const handleYaStartYN = async () => {
    try {
      //근로자 연말정산 시작 유무
      const response = await dispatch(getYaStartYN()).unwrap();
      const { resultCode } = response;
      if (resultCode === '1') {
        dispatch(setYaStart(true));
      } else {
        await handleYaStart();
      }
    } catch (error) {
      console.error('연말정산 상태 체크 오류:', error);
    }
  };

  const handleYaStart = async () => {
    try {
      //연말정산 테이블 생성 (시작 안했던 애들 태우는거야)
      const response = await dispatch(getYAStart()).unwrap();
      const { resultCode } = response;
      if (resultCode === '1') {
        setIsAuthLoaded(true);
        dispatch(setYaStart(true));
      } else {
        console.error('연말정산 테이블 생성 오류');
        // 추가적인 에러 처리 로직
      }
    } catch (error) {
      console.error('연말정산 테이블 생성 오류:', error);
    }
  };

  const handleLogin = async () => {
    try {
      if (callcenter == '') {
        //콜센터 번호 가져오기
        dispatch(getCallCenter());
      }

      //비밀번호 체크
      if (location.pathname !== '/myInfo') {
        const response = await dispatch(getHtmComPassCheck()).unwrap();
        const { resultCode } = response;
        if (resultCode == '1') {
          alertMessage(t('alertMessage.passwordMessage1'));
          navigate('/myInfo');
          return;
        } else {
          if (!myInfo?.htmPerSabun) dispatch(getInsaInfoLoad());
        }
      }
    } catch (error) {
      console.error('비밀번호 체크 오류:', error);
    }
  };

  if (!sessionId && !isLogin) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthLoaded) {
    return <>{children}</>;
  }

  return null;
};

export default AuthRoute;
